export enum ProgramUtilization {
  ReachedQuota = 100,
  High = 90,
  Medium = 75,
  Low = 50,
}
